<script setup lang="ts">
import { computed } from "vue";

import { cardKey } from "@/components/StickyNote/injectKeys";
import UserReactions from "@/components/UserReactions/UserReactions.vue";
import StickyLinksChip from "@/components/chip/StickyLinksChip.vue";
import { useBoardStore } from "@/store/board";
import { injectStrict } from "@/utils/vue";

import StickyNoteRow from "../../../StickyNoteRow.vue";

const card = injectStrict(cardKey);

const isActive = computed(() => card.id === useBoardStore().activeCardId);
</script>

<template>
  <StickyNoteRow class="note-footer">
    <UserReactions />
    <StickyLinksChip
      v-if="isActive"
      :linking-card="{ type: 'sticky', id: card.id }"
      show-upper-level-links
    />
  </StickyNoteRow>
</template>
